document.addEventListener("DOMContentLoaded", function () {

  const videos = document.querySelectorAll(".hero-banner__video");

  videos.forEach((video) => {

    // Required for iPhone autoplay
    video.muted = true;
    video.playsInline = true;
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");

    // Try autoplay
    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          // autoplay started
        })
        .catch(() => {

          // Retry after user interaction
          const startVideo = () => {
            video.play();

            document.removeEventListener("touchstart", startVideo);
            document.removeEventListener("click", startVideo);
          };

          document.addEventListener("touchstart", startVideo, {
            once: true
          });

          document.addEventListener("click", startVideo, {
            once: true
          });
        });
    }

  });

});